import { all, put, takeEvery, select } from 'redux-saga/effects'
import _ from 'lodash'

import { sendMessage } from '../helpers'
import { activeEntityStackTabSelector } from '../selectors'

import {
    changeEntityStackTab,
    entityStackRemoveNotification,
} from '../../../scenes/Gnosus/components/EntityStack/actions'
import { WS_CHANGE_ENTITY_STACK_TAB } from '../../../scenes/Gnosus/components/EntityStack/constants'

import { CHANGE_NEW_ENTITY_STACK_TAB } from './constants'
import { SOCKET_ON_MESSAGE, SOCKET_ACTION_TYPE } from '../constants'
import {
    WS_EXPORTS_REMOVE_TASK,
    WS_EXPORTS_REMOVE_NOTIFICATION,
    WS_EXPORTS_DOWNLOADE_FILE,
    WS_EXPORTS_CREATE_PDF_TASK,
    WS_EXPORTS_CREATE_XLS_TASK,
    WS_EXPORTS_INIT_LOAD,
} from '../../../scenes/Gnosus/components/EntityStack/components/StackContent/components/ExportsContent/constants'
import {
    exportsTaskRemove,
    exportsGetTaskFile,
    createPdfExportTask,
    createXlsExportTask,
    exportsInitLoad,
} from '../../../scenes/Gnosus/components/EntityStack/components/StackContent/components/ExportsContent/actions'

function* onMessageFromOld(_action) {
    const type = _.get(_action, 'data.type', null)
    const tabType = _.get(_action, 'data.content.tabType', {})
    const activeTab = yield select(activeEntityStackTabSelector)

    if (type === CHANGE_NEW_ENTITY_STACK_TAB && tabType !== activeTab) {
        // TODO: remove this check with full new entity stack implementation
        if (['groups', 'favourites', 'history', 'search', 'exports'].includes(tabType)) {
            yield put(changeEntityStackTab(tabType))
            return null
        }
    }

    if (type === WS_EXPORTS_REMOVE_TASK) {
        const module = _action?.data?.content?.module
        const entId = _action?.data?.content?.entId
        const jobId = _action?.data?.content?.jobId

        if (!module || !entId || !jobId) return null

        yield put(exportsTaskRemove(module, entId, jobId))

        return null
    }
    if (type === WS_EXPORTS_REMOVE_NOTIFICATION) {
        yield put(entityStackRemoveNotification('exports'))

        return null
    }
    if (type === WS_EXPORTS_DOWNLOADE_FILE) {
        const module = _action?.data?.content?.module
        const entId = _action?.data?.content?.entId
        const jobId = _action?.data?.content?.jobId

        if (!module || !entId || !jobId) return null

        yield put(exportsGetTaskFile(module, entId, jobId))

        return null
    }
    if (type === WS_EXPORTS_CREATE_PDF_TASK) {
        const module = _action?.data?.content?.module
        const entId = _action?.data?.content?.entId
        const settings = _action?.data?.content?.settings

        if (!module || !entId || _.isEmpty(settings)) return null

        yield put(createPdfExportTask(module, entId, settings))

        return null
    }
    if (type === WS_EXPORTS_CREATE_XLS_TASK) {
        const module = _action?.data?.content?.module
        const entId = _action?.data?.content?.entId
        const settings = _action?.data?.content?.settings

        if (!module || !entId || _.isEmpty(settings)) return null

        yield put(createXlsExportTask(module, entId, settings))

        return null
    }

    if (type === WS_EXPORTS_INIT_LOAD) {
        yield put(exportsInitLoad())

        return null
    }

    return null
}

function* wsChangeEntityTabCallSaga(_action) {
    const { activeTab } = _.get(_action, 'data', {})

    yield sendMessage(SOCKET_ACTION_TYPE.CHANGE_ENTITY_STACK_TAB, {
        type: SOCKET_ACTION_TYPE.CHANGE_ENTITY_STACK_TAB,
        tabType: activeTab,
    })

    return null
}

export default function* entityStackTabSaga() {
    yield all([
        takeEvery(SOCKET_ON_MESSAGE, onMessageFromOld),
        takeEvery(WS_CHANGE_ENTITY_STACK_TAB, wsChangeEntityTabCallSaga),
    ])
}
